import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'
import {ConnectionHandler} from 'relay-runtime'

import type {
  createRepositoryLabelMutation,
  createRepositoryLabelMutation$data,
  createRepositoryLabelMutation$variables,
} from './__generated__/createRepositoryLabelMutation.graphql'

export type CreateRepositoryLabelResponse = createRepositoryLabelMutation$data['createLabel']

export function commitCreateRepositoryLabelMutation({
  environment,
  input,
  repositoryId,
  connectionArgs,
  onError,
  onCompleted,
}: {
  environment: Environment
  input: createRepositoryLabelMutation$variables['input']
  repositoryId: string
  connectionArgs: Record<string, unknown>
  onError: (error: Error) => void
  onCompleted: (response: createRepositoryLabelMutation$data) => void
}) {
  return commitMutation<createRepositoryLabelMutation>(environment, {
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    mutation: graphql`
      mutation createRepositoryLabelMutation($input: CreateLabelInput!) {
        createLabel(input: $input) {
          label {
            id
            name
            nameHTML
            color
            description
          }
          errors {
            message
          }
        }
      }
    `,
    variables: {input},
    onError: error => onError?.(error),
    onCompleted: response => onCompleted?.(response),
    updater: store => {
      const repo = store.get(repositoryId)
      if (!repo) return
      const conn = repo.getLinkedRecord('labels', connectionArgs)
      if (!conn) return

      const payload = store.getRootField('createLabel')
      if (!payload) return
      const newLabel = payload.getLinkedRecord('label')
      if (!newLabel) return

      const edge = ConnectionHandler.createEdge(store, conn, newLabel, 'LabelEdge')
      ConnectionHandler.insertEdgeBefore(conn, edge)

      const count = (conn.getValue('totalCount') as number) ?? 0
      conn.setValue(count + 1, 'totalCount')
    },
  })
}
